export const UNREGISTERED_USER_IDS = ['GUEST_USER'];
